export default {"src":"/_next/static/media/helpIcon.c0f852f6.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};